import {useMutation} from "@tanstack/react-query";
import axios, {AxiosError} from "axios";
import {ApiConfig} from "@/config/api.config.ts";
import {ProblemDetails} from "@/@types/base.types.ts";
import {
    CompleteMigrationRequestDto,
    LoginResponseDto,
    TwoFactorAuthResponseDto,
} from "@/@types/auth.types.ts";

type Props = {
    onSuccess?: (result: LoginResponseDto | TwoFactorAuthResponseDto) => void;
    onError?: (error: AxiosError<ProblemDetails>) => void;
};

export const useCompleteMigrationApi = ({onSuccess, onError}: Props) => {
    const {mutateAsync: doCompleteMigration, isPending: isCompleteMigrationWorking} = useMutation({
        mutationKey: [ApiConfig.queries.auth.completeMigration.queryKey],
        mutationFn: async (
            request: CompleteMigrationRequestDto,
        ): Promise<LoginResponseDto | TwoFactorAuthResponseDto> => {
            // Unauthenticated request (the user is mid-migration), so use a clean axios instance.
            const axiosInstance = axios.create({baseURL: ApiConfig.currentUrls.api});
            const response = await axiosInstance.post<LoginResponseDto | TwoFactorAuthResponseDto>(
                ApiConfig.queries.auth.completeMigration.endpoint,
                request,
            );
            return response.data;
        },
        onSuccess: (result) => {
            onSuccess?.(result);
        },
        onError: (error: AxiosError<ProblemDetails>) => {
            onError?.(error);
        },
    });

    return {
        doCompleteMigration,
        isCompleteMigrationWorking,
    };
};
